<template>
  <div class="MainVisual">
    <div id="mainvisual_area_css" class="MainVisual__area">
      <div ref="visualText" class="MainVisual__tx_area">
        <p class="MainVisual__tx_main">
          {{ keyVisual.title }}
        </p>
        <p class="MainVisual__tx_sab">
          {{ keyVisual.sub_title }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import keyVisualService from '@/services/keyVisualService'
export default {
  name: 'HomeBanner',
  data() {
    return {
      image: 'assets/img/kv.png',
      keyVisual: {
        title: '',
        sub_title: '',
        image: ''
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.$emit('updateLoadingBanner', true)
      const response = await keyVisualService.get()
      const resizeObserver = new ResizeObserver((entries) => {
        console.log('visual text height', entries[0].target.clientHeight)
        if (window.innerWidth < 768) {
          const mt = (-window.innerHeight * 0.8 + entries[0].target.clientHeight)
          if (document.getElementsByClassName('Imp__con').length) {
            document.getElementsByClassName('Imp__con')[0].style.marginTop = mt + 'px'
          } else {
            document.getElementsByClassName('Class__con')[0].style.marginTop = mt + 'px'
            document.getElementsByClassName('Class__con')[0].style.minHeight = -mt + 'px'
          }
        }
      })
      resizeObserver.observe(this.$refs.visualText)
      if (response.data) {
        this.keyVisual.title = response.data.title
        this.keyVisual.sub_title = response.data.sub_title
        this.keyVisual.image = response.data.image_url
        document.getElementById('mainvisual_area_css').style.background = "url('" + response.data.image_url + "') center top 50% no-repeat"
      }
      this.$emit('updateLoadingBanner', false)
    }
  }
}
</script>
